import { useNavigate, useOutletContext, useParams } from 'react-router-dom'

import { TimePlanningProfileIndexPageDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import type Employee from 'modules/employees/store/models/Employee'
import PlanningVersions from 'modules/time_planning/pages/PlanningVersionsPage'

const IndexPage = () => {
  const { navigation } = useNavigation()

  const { employee } = useOutletContext<{ employee: Employee }>()
  const { planningVersionId } = useParams()
  const navigate = useNavigate()

  const { data, loading } = useQuery(TimePlanningProfileIndexPageDocument, {
    variables: {
      employeeId: Number(employee.id),
      planningVersionId: Number(planningVersionId),
    },
  })

  const authorized = data?.employees.employee?._policies?.seePlanningVersions?.can
  const currentPlanningVersionId = data?.timePlanning.planningVersionsConnection.nodes[0]?.id

  useUnsafeEffect(() => {
    if (!authorized) {
      navigate(navigation.profile.fullPath())
    }
  }, [authorized])

  useUnsafeEffect(() => {
    if (!planningVersionId) {
      navigate(
        navigation.profile.planningVersions.planningVersionId.fullPath({
          planningVersionId: currentPlanningVersionId ?? 0, // 0 is the default planning version
        })
      )
    }
  }, [planningVersionId, currentPlanningVersionId])

  if (loading) return <Loading />

  return <PlanningVersions />
}

export default IndexPage
